<div class="contact-section" id="contact">
    <div class="container">
      <!-- Contact Header -->
      <div class="section-header">
        <h2 class="section-title">
          <span class="title-text">اتصل بنا</span>
          <span class="title-decoration"></span>
        </h2>
      </div>
  
      <div class="contact-content">
        <div class="contact-grid">
          <!-- Contact Form -->
          <div class="contact-form-container">
            <form [formGroup]="contactForm" (ngSubmit)="onFormSubmit()" class="contact-form">
              <div class="form-row">
                <div class="form-group half-width">
                  <input type="text" name="name" formControlName="fullName" id="name" class="form-input" required placeholder="الاسم بالكامل">
                  <div *ngIf="contactForm.get('fullName').invalid && contactForm.get('fullName').touched" class="error-message">
                    <i class="fas fa-exclamation-circle"></i> الرجاء إدخال الاسم كاملاً
                  </div>
                </div>
  
                <div class="form-group half-width">
                  <input type="email" name="email" id="email" formControlName="email" class="form-input" required placeholder="yourmail@mail.com">
                  <div *ngIf="contactForm.get('email').invalid && contactForm.get('email').touched" class="error-message">
                    <i class="fas fa-exclamation-circle"></i> يرجى إدخال بريد إلكتروني صحيح
                  </div>
                </div>
              </div>
  
              <div class="form-row">
                <div class="form-group half-width" dir="ltr">
                  <input type="text" name="phone_number" id="phone_number" formControlName="phone" required class="form-input" placeholder="+966XXXXXXXXX">
                  <div *ngIf="contactForm.get('phone').invalid && contactForm.get('phone').touched" class="error-message">
                    <i class="fas fa-exclamation-circle"></i> يرجى إدخال رقم هاتف صحيح
                  </div>
                </div>
  
                <div class="form-group half-width">
                  <input type="text" name="msg_subject" id="msg_subject" formControlName="subject" class="form-input" required placeholder="الموضوع">
                  <div *ngIf="contactForm.get('subject').invalid && contactForm.get('subject').touched" class="error-message">
                    <i class="fas fa-exclamation-circle"></i> الرجاء إدخال موضوع الرسالة
                  </div>
                </div>
              </div>
  
              <div class="form-group">
                <textarea name="message" class="form-input textarea" id="message" formControlName="content" cols="30" rows="6" required placeholder="الرسالة"></textarea>
                <div *ngIf="contactForm.get('content').invalid && contactForm.get('content').touched" class="error-message">
                  <i class="fas fa-exclamation-circle"></i> الرجاء إدخال محتوى الرسالة
                </div>
              </div>
  
              <div class="form-submit">
                <button type="submit" class="submit-btn" [disabled]="contactForm.invalid">
                  إرسال الرسالة
                  <i class="fas fa-paper-plane"></i>
                </button>
              </div>
            </form>
          </div>
  
          <!-- Contact Info -->
          <div class="contact-info-container">
            <div class="contact-info-card">
              <h3 class="info-title">تواصل معنا عبر رقم هاتفك أو عنوان بريدك الإلكتروني</h3>
              
              <div class="contact-method">
                <div class="contact-icon">
                  <i class="fas fa-phone"></i>
                </div>
                <a href="tel:+966596677065" class="contact-link">+966 59 667 7065</a>
              </div>
  
              <div class="contact-method">
                <div class="contact-icon">
                  <i class="fas fa-envelope"></i>
                </div>
                <a href="mailto:info@kharaaj.com" class="contact-link">info@kharaaj.com</a>
              </div>
  
              <div class="contact-method">
                <div class="contact-icon">
                  <i class="fas fa-map-marker-alt"></i>
                </div>
                <span class="contact-address">جدة – حي الرحمانية شارع الفروسية</span>
              </div>
  
              <div class="contact-divider">
                <span class="divider-text">أو تواصل معنا عبر</span>
              </div>
  
              <div class="social-links">
                <a href="https://www.youtube.com/channel/UCHKg5f08j0G2xhMjQQdpySA" target="_blank" class="social-link youtube">
                  <i class="fab fa-youtube"></i>
                </a>
                <a href="https://twitter.com/kharaajsa" target="_blank" class="social-link twitter">
                  <i class="fab fa-twitter"></i>
                </a>
                <a href="https://www.snapchat.com/add/kharaajsa" target="_blank" class="social-link snapchat">
                  <i class="fab fa-snapchat"></i>
                </a>
                <a href="https://www.instagram.com/kharaajsa/" target="_blank" class="social-link instagram">
                  <i class="fab fa-instagram"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>